module.exports = __webpack_public_path__ + "static/media/add.0f2896db.svg";